import React from "react";

export default function Signal2({
  fill = "black",
  width = "40px",
  height = "40px",
  ...others
}) {
  return (
    <svg 
    width={width}
    height={height}
    viewBox="0 0 700 500" 
    xmlns="http://www.w3.org/2000/svg"
    {...others}>
      <g>
        <path d="m198.1 340.2c-4.8984 0-9.1016 4.1992-9.1016 9.1016v68.598c0 5.6016 4.1992 9.1016 9.1016 9.1016h55.301c4.8984 0 9.1016-3.5 9.1016-9.1016v-68.598c0-4.8984-4.1992-9.1016-9.1016-9.1016z" fill={fill}/>
        <path d="m280.7 270.9c-4.8984 0-9.1016 4.1992-9.1016 9.1016v137.9c0 5.6016 4.1992 9.1016 9.1016 9.1016h55.301c4.8984 0 9.1016-3.5 9.1016-9.1016v-137.9c0-4.8984-4.1992-9.1016-9.1016-9.1016z" fill={fill}/>
        <path d="m364 202.3c-4.8984 0-9.1016 3.5-9.1016 8.3984v207.2c0 5.6016 4.1992 9.1016 9.1016 9.1016h55.301c4.8984 0 8.3984-3.5 8.3984-9.1016v-207.2c0-4.8984-3.5-8.3984-8.3984-8.3984zm8.3984 17.5h37.801v189.7h-37.801z" fill={"#e0e0e0"}/>
        <path d="m446.6 133c-4.8984 0-9.1016 4.1992-9.1016 9.1016v275.8c0 5.6016 4.1992 9.1016 9.1016 9.1016h55.301c4.8984 0 9.1016-3.5 9.1016-9.1016v-275.8c0-4.8984-4.1992-9.1016-9.1016-9.1016zm9.1016 18.199h37.102v258.3l-37.102 0.003906z" fill={"#e0e0e0"}/>
      </g>
    </svg>
  );
}
